// useProvidedSessionInactivity.ts
import { inject } from 'vue';
import { useSessionInactivity } from './useSessionInactivity';

export function useProvidedSessionInactivity() {
  const inactivity = inject<ReturnType<typeof useSessionInactivity>>('sessionInactivity');

  if (!inactivity) {
    throw new Error('Session inactivity not provided');
  }

  return inactivity;
}
